import { fetchIbpAdvanceFilters } from 'service/service';

export interface IbpAdvancedFilterOptions {
  projectName: string[];
  sectors: string[];
  reports: string[];
  markets: string[];
  gdoStatus: string[];
}

export const emptyIbpAdvancedFilterOptions = (): IbpAdvancedFilterOptions => ({
  projectName: [],
  sectors: [],
  reports: [],
  markets: [],
  gdoStatus: [],
});

const toFilterValues = (values: any): string[] => {
  if (!Array.isArray(values)) return [];

  return values
    .map((value: any) => value?.name || value?.label || value?.value || value)
    .filter((value: any): value is string => typeof value === 'string' && value.trim().length > 0);
};

export const normalizeIbpAdvancedFilters = (response: any): IbpAdvancedFilterOptions => {
  const data = response?.data?.data || response?.data || response || {};
  const options = emptyIbpAdvancedFilterOptions();

  Object.keys(options).forEach((key) => {
    options[key as keyof IbpAdvancedFilterOptions] = toFilterValues(data[key]);
  });

  return options;
};

export const fetchIbpAdvancedFilterOptions = async (
  payload: any = {},
): Promise<IbpAdvancedFilterOptions> => {
  try {
    return normalizeIbpAdvancedFilters(await fetchIbpAdvanceFilters(payload));
  } catch (error) {
    console.error('Failed to load IBP advanced filters', error);
    return emptyIbpAdvancedFilterOptions();
  }
};